import React from 'react';
import styles from '../../styles/molecules/modal.module.scss';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children, className }) => {
  if (!isOpen) return null;

  return (
    <div className={`${styles.modalOverlay}`} onClick={onClose}>
      <div className={`${styles.modalContent} ${className || ''}`} onClick={(e) => e.stopPropagation()}>

        {children}
      </div>
    </div>
  );
};

export default Modal; 